import React, { FC, MouseEvent } from 'react';

import classNames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from './active-filters.module.scss';

import { Button, Close } from 'views/components/UI';

interface IActiveFilterItem {
  id: string | number;
  label: string;
  category?: string;
  onEdit?: (event: MouseEvent<HTMLButtonElement>) => void;
  onRemove: () => void;
}

interface IActiveFiltersProps {
  filters: IActiveFilterItem[];
  onClearAll?: () => void;
  className?: string;
}

const ActiveFilters: FC<IActiveFiltersProps> = props => {
  const { filters, onClearAll, className } = props;
  const intl = useIntl();

  if (!filters.length) {
    return null;
  }

  return (
    <div className={classNames(styles['active-filters'], className)}>
      {filters.map(filter => (
        <div key={filter.id} className={styles['active-filters__chip']}>
          {filter.onEdit ? (
            <button
              type="button"
              className={styles['active-filters__edit']}
              onClick={filter.onEdit}
            >
              {filter.category && (
                <span className={styles.category}>{filter.category} </span>
              )}
              <span className={styles['active-filters__label']}>{filter.label}</span>
            </button>
          ) : (
            <span className={styles['active-filters__label']}>{filter.label}</span>
          )}
          <button
            aria-label={
              filter.category
                ? intl.formatMessage(
                    { id: 'filters.remove-value' },
                    { category: filter.category, value: filter.label },
                  )
                : intl.formatMessage({ id: 'active-filters.btn.remove' })
            }
            className={styles['active-filters__remove']}
            onClick={filter.onRemove}
            type="button"
          >
            <Close color="var(--sk-icon-default)" size="16px" />
          </button>
        </div>
      ))}

      {onClearAll && (
        <Button size="small" mode="tertiary" color="dark" onClick={onClearAll}>
          <FormattedMessage id="company-members.modal-filter.button.delete-all" />
        </Button>
      )}
    </div>
  );
};

export { ActiveFilters };
